import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
const TechnicalFaq = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === faqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(faqData.map((_, i) => i));
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const faqData = [
    {
      question: "What is Technical Maintenance?",
      answer:
        "Technical Maintenance involves the regular upkeep of software applications, servers, and network infrastructure to ensure optimal performance, security, and reliability.",
    },
    {
      question: "Why is Technical Maintenance important?",
      answer:
        "It prevents unexpected downtime, addresses vulnerabilities, improves application performance, and ensures compatibility with the latest technologies.",
    },
    {
      question:
        "What are the key activities included in Technical Maintenance?",
      answer:
        "Key activities include software updates, security patches, performance optimization, data backups, and regular monitoring of systems and networks.",
    },
    {
      question: "How often should Technical Maintenance be performed?",
      answer:
        "The frequency depends on the application and business needs, but regular maintenance schedules—monthly, quarterly, or annually—are recommended for optimal performance.",
    },
    {
      question: "Can Technical Maintenance be automated?",
      answer:
        "Yes, many maintenance tasks such as backups, updates, and monitoring can be automated to reduce manual effort and minimize human error.",
    },
  ];

  return (
    <div className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
          <div className="w-full text-center md:pb-10">
            <h2 className="text-xl md:text-3xl font-semibold text-main">
              Frequently Asked Questions (Faq)
            </h2>
            <div className="border-b-4 border-main w-20 md:w-40 mx-auto my-2 rounded-full" />
          </div>

          <button
            onClick={toggleAll}
            className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap sm:self-end"
          >
            {openIndexes.length === faqData.length
              ? "Collapse all"
              : "Expand all"}
          </button>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl shadow-sm overflow-hidden"
              data-aos="fade-up"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full bg-primaryPri flex justify-between items-center px-6 py-4 text-left"
              >
                <p className="md:text-lg text-sm font-medium text-black">
                  {item.question}
                </p>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`w-3 h-3 transform transition-transform ${
                    openIndexes.includes(index) ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndexes.includes(index) && (
                <div
                  className="px-6 pb-4 text-gray-700 text-xs md:text-sm"
                  data-aos="fade-down"
                >
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnicalFaq;
